import React from 'react';
import TabComponent from '../../components/TabComponent';
import { t } from '../../i18n/t';
import { buildSearchCondition } from '../../components/search/SearchUtils';
import TestPlanDataTable from '../../components/table/TestPlanDataTable';

class RunConfigurationsTab extends TabComponent {
  constructor(props) {
    super(props);
    this.meta.id = 'page-release-details-run-configuration';
  }

  renderExecutions() {
    const { release } = this.props;
    return (
      <TestPlanDataTable
        defaultSearchConditions={[
          buildSearchCondition('Release.id', '=', release.id),
        ]}
      />
    );
  }

  render() {
    return this.renderExecutions();
  }
}

export default RunConfigurationsTab;
